import { render } from "./RegistroRevendedorView.vue?vue&type=template&id=7406e56a"
import script from "./RegistroRevendedorView.vue?vue&type=script&lang=js"
export * from "./RegistroRevendedorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__